import { FiShare2 } from "react-icons/fi";

const ProductShare = ({ productName }) => {

  const handleShare = () => {
    const url = window.location.href;

    if (navigator.share) {
      navigator.share({
        title: productName,
        url: url
      });
    } else {
      navigator.clipboard.writeText(url);
      alert("Product link copied!");
    }
  };

  return (
    <div className="mt-4">
      <button
        onClick={handleShare}
        className="flex items-center gap-2 text-sm text-black hover:underline"
      >
        <FiShare2 />
        Share Product
      </button>
    </div>
  );
};

export default ProductShare;